module.exports = __webpack_public_path__ + "static/media/fullstackimg.0d920f6a.png";